import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import Amount from "@/models/Shared/Amount";

export default class DepositOverdraftSettings extends BaseProductSettings {
    enabled: boolean = true;
    hardLimit: Amount = new Amount();
    softLimit: Amount = new Amount();
    reviewDateUtc: Date;
}